'use strict';

var React = require('react');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { default: e }; }

var React__default = /*#__PURE__*/_interopDefaultCompat(React);

function SvgExport(props) {
    return (React__default.default.createElement("svg", { width: "1em", height: "1em", viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg", ...props },
        React__default.default.createElement("g", { fill: "none", fillRule: "evenodd" },
            React__default.default.createElement("path", { d: "M0 0h16v16H0z" }),
            React__default.default.createElement("path", { d: "M2 2h12v12H2z" }),
            React__default.default.createElement("path", { d: "M12 12.667H4A.669.669 0 013.333 12V4c0-.367.3-.667.667-.667h3.333c.367 0 .667-.3.667-.666C8 2.3 7.7 2 7.333 2h-4C2.593 2 2 2.6 2 3.333v9.334C2 13.4 2.6 14 3.333 14h9.334C13.4 14 14 13.4 14 12.667v-4C14 8.3 13.7 8 13.333 8c-.366 0-.666.3-.666.667V12c0 .367-.3.667-.667.667zM9.09 2.7c0 .386.316.702.702.702h1.816L5.205 9.806a.698.698 0 10.989.989l6.403-6.403v1.816c0 .386.316.701.702.701a.703.703 0 00.701-.7V2.7A.703.703 0 0013.299 2H9.792a.703.703 0 00-.701.701z", fill: "currentColor" }))));
}

module.exports = SvgExport;
//# sourceMappingURL=Export.js.map
